export default "__VITE_ASSET__Bql1rkew__"